<template>
  <div :aria-live="silent ? 'off' : 'assertive'">
    <div v-show-slide="show">
      <div
        :class="[
          `alert alert-${type}`,
          { 'alert-msg-slim': slim },
          outerClass
        ]"
      >
        <div :class="['d-flex gap-3', innerClass]">
          <span :class="`alert-msg-icon bi bi-${iconSubClass}`"></span>
          <div class="alert-msg-body">
            <h5 v-if="title">{{ title }}</h5>
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    innerClass: String,
    outerClass: String,

    show: {
      type: Boolean,
      default: () => true
    },

    silent: {
      type: Boolean,
      default: () => false
    },

    slim: {
      type: Boolean,
      default: () => false
    },

    title: String,

    type: {
      type: String,
      required: true,
      validator: value => ['info', 'success', 'warning', 'danger'].includes(value)
    }
  },

  computed: {
    iconSubClass: ({ type }) => ({
      info: 'info-circle-fill',
      success: 'exclamation-circle-fill',
      warning: 'exclamation-triangle-fill',
      danger: 'exclamation-circle-fill'
    }[type])
  }
};
</script>

<style lang="scss" scoped>
.alert-msg-icon {
  font-size: 2em;
}

.alert-msg-slim {
  padding-bottom: 0.75em;
  padding-top: 0.75em;

  .alert-msg-icon {
    font-size: 1.5em;
  }
}

.alert-msg-body {
  padding-top: 0.35rem;
}
</style>
